<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div
      class="modal fade"
      id="networks-columns"
      tabindex="-1"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>

            <div class="text-center">
              <h4 class="mb-2">{{ $t("nases.networks_columns") }}</h4>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Profile"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-device-nintendo"></i>
                        <span class="custom-option-title">
                          {{ $t("nases.name") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.name.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="Profile"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="firstname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-topology-star"></i>
                        <span class="custom-option-title">
                          {{ $t("nases.ip") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.ip.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="firstname"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lastname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-lock"></i>
                        <span class="custom-option-title">
                          {{ $t("nases.secret") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.secret.enabled"
                        @change="updateColumns"
                        value=""
                        id="lastname"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Price"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-user-hexagon"></i>
                        <span class="custom-option-title">
                          {{ $t("nases.username") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.username.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="Price"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="prefix"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-key"></i>
                        <span class="custom-option-title">
                          {{ $t("nases.password") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.password.enabled"
                        @change="updateColumns"
                        value=""
                        id="prefix"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lineNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-hierarchy-2"></i>
                        <span class="custom-option-title">
                          {{ $t("nases.api_port") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.api_port.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="lineNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="portNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-share"></i>
                        <span class="custom-option-title">
                          {{ $t("nases.community") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.community.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="portNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Notes"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-letter-v-small"></i>
                        <span class="custom-option-title">
                          {{ $t("nases.version") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.legacy.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="Notes"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ip"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-user-shield"></i>
                        <span class="custom-option-title">
                          {{ $t("nases.allowed_admins") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="columns.allowed_admins.enabled"
                        @change="updateColumns"
                        value=""
                        id="ip"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="expirationDate"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-brand-databricks"></i>
                        <span class="custom-option-title">
                          {{ $t("nases.allowed_profiles") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.allowed_profiles.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="expirationDate"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ASessions"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-world-check"></i>
                        <span class="custom-option-title">
                          {{ $t("nases.online_sessions") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.online_sessions.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="ASessions"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Status"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-progress"></i>
                        <span class="custom-option-title">
                          {{ $t("nases.status") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.online.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="Status"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Api"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-api"></i>
                        <span class="custom-option-title">
                          {{ $t("nases.api") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.api_connected.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="Api"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="wa"
                    >
                      <span class="custom-option-body">
                        <div class="text-center flex justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-whatsapp"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"
                            />
                          </svg>
                        </div>
                        <span class="custom-option-title">
                          {{ $t("nases.whatsapp_status") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.wa_status.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="wa"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="wa_name"
                    >
                      <span class="custom-option-body">
                        <div class="text-center flex justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-whatsapp"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"
                            />
                          </svg>
                        </div>
                        <span class="custom-option-title">
                          {{ $t("nases.whatsapp_network_name") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.wa_name.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="wa_name"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Settings"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-settings"></i>
                        <span class="custom-option-title">
                          {{ $t("nases.settings") }}
                        </span>
                      </span>
                      <input
                        class="form-check-input"
                        v-model="columns.settings.enabled"
                        @change="updateColumns"
                        type="checkbox"
                        value=""
                        id="Settings"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <deviceAdd
      v-if="showAddNas"
      :visible="showAddNas"
      @updated="
        showAddNas = false;
        $router.push({ query: {} });
        applyFilters();
      "
    />
    <DeviceQrcode
      v-if="showQrCode && hasPrivilege('nases_edit_nases')"
      :visible="showQrCode"
      :selected-nas="selectedNas"
    />

    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div
              class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    class="btn btn-primary waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                    v-if="hasPrivilege('nases_edit_nases')"
                    @click="openAddNasModal()"
                    :class="{
                      disabled_ssr: !this.$store.getters.settings.license
                        .active,
                    }"
                  >
                    <span>
                      <i class="ti ti-plus ti-xs me-2"></i>
                      <span class=" ">{{ $t("nases.add_nas") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div
              class="col-12 col-md-8 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    type="button"
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i>Print</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i>Csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-export me-2"></i>Excel</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i>Pdf</a
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
              >
                <label>
                  <input
                    type="search"
                    class="form-control"
                    @change="applyFilters"
                    v-model="filters.search_query"
                    v-if="hasPrivilege('nases_view_search_nases')"
                    :placeholder="$t('control.search')"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row mx-1 mt-n6" bis_skin_checked="1">
            <div
              class="col-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start gap-2"
              bis_skin_checked="1"
            >
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label
                  >{{ $t("control.show") }}
                  <select
                    v-model="filters.rows"
                    @change="applyFilters"
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#networks-columns"
                    class="btn btn-secondary  waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-scan-eye ti-s me-md-2"></i>
                      <span class="d-md-inline-block d-none">{{
                        $t("control.columns_visible")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-1 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-n6 mt-md-0"
              bis_skin_checked="1"
            ></div>

            <div
              class="col-12 col-md-6 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': autoUpdate,
                      'btn-secondary': !autoUpdate,
                    }"
                    @click.prevent="toggleAutoUpdate"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-refresh ti-s me-2"></i>
                      <span class=" ">{{ $t("control.auto_update") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': filters.save,
                      'btn-secondary': !filters.save,
                    }"
                    @click.prevent="toggleSaveFilters"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-filter-check ti-s me-2"></i>
                      <span class=" ">{{ $t("control.save_filters") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table"
                id="DataTables_Table_0"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th></th>
                    <th>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="allSelected"
                        @click="checkAll"
                      />
                    </th>
                    <th class="sorting" v-if="columns.name.enabled">
                      {{ $t("nases.name") }}
                    </th>
                    <th class="sorting" v-if="columns.ip.enabled">
                      {{ $t("nases.ip") }}
                    </th>
                    <th class="sorting" v-if="columns.secret.enabled">
                      {{ $t("nases.secret") }}
                    </th>
                    <th class="sorting" v-if="columns.username.enabled">
                      {{ $t("nases.username") }}
                    </th>
                    <th class="sorting" v-if="columns.password.enabled">
                      {{ $t("nases.password") }}
                    </th>
                    <th class="sorting" v-if="columns.api_port.enabled">
                      {{ $t("nases.api_port") }}
                    </th>
                    <th class="sorting" v-if="columns.community.enabled">
                      {{ $t("nases.community") }}
                    </th>
                    <th class="sorting" v-if="columns.legacy.enabled">
                      {{ $t("nases.version") }}
                    </th>
                    <th class="sorting" v-if="columns.allowed_admins.enabled">
                      {{ $t("nases.allowed_admins") }}
                    </th>
                    <th class="sorting" v-if="columns.allowed_profiles.enabled">
                      {{ $t("nases.allowed_profiles") }}
                    </th>
                    <th class="sorting" v-if="columns.online_sessions.enabled">
                      {{ $t("nases.online_sessions") }}
                    </th>
                    <th class="sorting" v-if="columns.online.enabled">
                      {{ $t("nases.status") }}
                    </th>
                    <th class="sorting" v-if="columns.api_connected.enabled">
                      {{ $t("nases.api") }}
                    </th>
                    <th class="sorting" v-if="columns.wa_status.enabled">
                      {{ $t("nases.whatsapp_status") }}
                    </th>
                    <th class="sorting" v-if="columns.wa_name.enabled">
                      {{ $t("nases.whatsapp_network_name") }}
                    </th>
                    <th class="sorting" v-if="columns.settings.enabled">
                      {{ $t("nases.settings") }}
                    </th>
                  </tr>
                  <tr v-if="hasPrivilege('nases_view_search_nases')">
                    <th></th>
                    <th></th>
                    <th
                      v-if="columns.name.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                        v-model="filters.name"
                        @change="applyFilters"
                      />
                    </th>
                    <th
                      v-if="columns.ip.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('control.search')"
                        v-model="filters.ip"
                        @change="applyFilters"
                      />
                    </th>
                    <th
                      v-if="columns.secret.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.username.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.password.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.api_port.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.community.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th v-if="columns.legacy.enabled"></th>
                    <th v-if="columns.allowed_admins.enabled"></th>
                    <th v-if="columns.allowed_profiles.enabled"></th>
                    <th v-if="columns.online_sessions.enabled"></th>
                    <th
                      v-if="columns.online.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.api_connected.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.wa_status.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.wa_name.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th v-if="columns.settings.enabled"></th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th
                      v-for="(item, index) in Object.values(columns).filter(
                        (col) => col?.enabled === true
                      ).length"
                      :key="index"
                    >
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(nas, index) in dataList" :key="nas.id">
                    <th>
                      <div class="dropdown" v-if="selection_array.length <= 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul
                          class="dropdown-menu"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                        >
                          <li>
                            <button
                              @click="openAddNasModal(nas)"
                              v-if="hasPrivilege('nases_edit_nases')"
                              class="dropdown-item text-primary"
                            >
                              <i class="ti ti-eye me-2"></i
                              >{{ $t("actions.view") }}
                            </button>
                          </li>
                          <li>
                            <button
                              @click="openQrCodeModal(nas)"
                              v-if="
                                hasPrivilege('nases_edit_nases') &&
                                  nas.wa_status == 'ready_to_connect'
                              "
                              class="dropdown-item text-success"
                            >
                              <i class="ti ti-scan me-2"></i
                              >{{ $t("nases.link_whatsapp") }}
                            </button>
                          </li>
                          <li>
                            <button
                              @click="exportSQL(nas.id)"
                              class="dropdown-item text-primary"
                            >
                              <i class="ti ti-database me-2"></i
                              >{{ $t("actions.export_nas") }}
                            </button>
                          </li>
                          <li>
                            <button
                              @click="deleteData(nas)"
                              v-if="hasPrivilege('nases_delete_nases')"
                              class="dropdown-item text-danger"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <td scope="row">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="nas.selected"
                        @click="selectData(nas)"
                      />
                    </td>
                    <td scope="row" v-if="columns.name.enabled">
                      <a
                        :href="`?nas_id=${nas.id}`"
                        @click.prevent="openAddNasModal(nas)"
                        >{{ nas.name }}</a
                      >
                    </td>
                    <td v-if="columns.ip.enabled">{{ nas.ip }}</td>
                    <td v-if="columns.secret.enabled">
                      {{ nas.radius_secret }}
                    </td>
                    <td v-if="columns.username.enabled">
                      {{ nas.api_username }}
                    </td>
                    <td v-if="columns.password.enabled">
                      {{ nas.api_password }}
                    </td>
                    <td v-if="columns.api_port.enabled">{{ nas.api_port }}</td>
                    <td v-if="columns.community.enabled">
                      {{ nas.snmp_community }}
                    </td>
                    <td v-if="columns.legacy.enabled">
                      <span v-if="!nas.legacy" class="badge bg-label-info me-1"
                        >v3.36+</span
                      >
                      <span
                        v-if="nas.legacy"
                        class="badge bg-label-warning me-1"
                        >v3.36</span
                      >
                    </td>
                    <td v-if="columns.allowed_admins.enabled">
                      <div style="max-height: 50px; overflow-y: scroll;">
                        <span
                          v-for="admin in nas.allowed_users"
                          :key="admin.id"
                          class="badge bg-label-primary mb-1 me-1"
                          >{{ admin.email }}</span
                        >
                      </div>
                    </td>
                    <td v-if="columns.allowed_profiles.enabled">
                      <div style="max-height: 50px; overflow-y: scroll;">
                        <span
                          v-for="profile in nas.allowed_profiles"
                          :key="profile.id"
                          class="badge bg-label-primary mb-1 me-1"
                          >{{ profile.name }}</span
                        >
                      </div>
                    </td>
                    <td v-if="columns.online_sessions.enabled">
                      <span class="badge bg-label-primary me-1">{{
                        nas.online_sessions
                      }}</span>
                    </td>
                    <td v-if="columns.online.enabled">
                      <div v-if="hasPrivilege('nases_view_nases_status')">
                        <span
                          v-if="nas.online == 'up'"
                          class="badge bg-label-success me-1"
                          >{{ $t("control.online") }}</span
                        >
                        <span
                          v-if="nas.online == 'down'"
                          class="badge bg-label-danger me-1"
                          >{{ $t("control.offline") }}</span
                        >
                        <span
                          v-if="nas.online == 'loading'"
                          class="badge me-1 text-primary"
                          ><div class="spinner-border"></div
                        ></span>
                      </div>
                    </td>
                    <td v-if="columns.api_connected.enabled">
                      <div v-if="hasPrivilege('nases_view_nases_status')">
                        <span
                          v-if="nas.api_connected == 'up'"
                          class="badge bg-label-success me-1"
                          >{{ $t("control.online") }}</span
                        >
                        <span
                          v-if="nas.api_connected == 'down'"
                          class="badge bg-label-danger me-1"
                          >{{ $t("control.offline") }}</span
                        >
                        <span
                          v-if="nas.api_connected == 'loading'"
                          class="badge me-1 text-primary"
                          ><div class="spinner-border"></div
                        ></span>
                      </div>
                    </td>
                    <td v-if="columns.wa_status.enabled">
                      <div
                        v-if="nas.wa_status == 'connected'"
                        class="badge bg-label-success me-1"
                      >
                        {{ $t("control.online") }}
                      </div>
                      <div
                        v-else-if="nas.wa_status == 'ready_to_connect'"
                        class="badge bg-label-warning me-1 underline cursor-pointer text-primary"
                        @click="openQrCodeModal(nas)"
                      >
                        {{ $t("nases.scan_qr_code") }}
                      </div>
                      <div
                        v-else-if="nas.wa_status == 'error'"
                        class="badge bg-label-danger me-1"
                      >
                        {{ $t("control.error") }}
                      </div>
                      <div v-else-if="nas.wa_status == 'no_instance'" class="">
                        {{ $t("nases.whatsapp_code_not_found") }}
                      </div>
                      <div v-else-if="nas.wa_status == 'invalid'">
                        {{ $t("nases.invalid_whatsapp_code") }}
                      </div>
                      <div v-else-if="nas.wa_status == 'loading'">
                        <div class="spinner-border"></div>
                      </div>
                      <div v-else>
                        {{ nas.wa_status }}
                      </div>
                    </td>
                    <td v-if="columns.wa_name.enabled">
                      {{ nas.wa_name }}
                    </td>
                    <td>
                      <button
                        v-if="
                          nas.api_connected == 'up' &&
                            !nas.commited &&
                            hasPrivilege('nases_edit_nases')
                        "
                        @click="commitSettings(nas)"
                        :class="{
                          disabled_ssr: !this.$store.getters.settings.license
                            .active,
                        }"
                        class="btn btn-primary waves-effect waves-light"
                      >
                        {{ $t("control.commit") }}
                      </button>
                      <div v-if="nas.commited" class="text-success">
                        {{ $t("control.commited") }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { hasPrivilege } from "../global_constants.js";
import { mapGetters } from "vuex";
import deviceAdd from "../components/modals/device-add.vue";
import DeviceQrcode from "../components/modals/device-qrcode.vue";
export default {
  components: {
    deviceAdd,
    DeviceQrcode,
  },
  name: "Networks",
  data() {
    return {
      dataList: null,
      meta: { last_page: 0 },
      selectedData: null,
      showDetails: false,
      showDelete: false,
      showDeleteAll: false,
      showContext: false,
      showQrCode: false,
      selectedNas: null,
      loading: true,
      showFilters: false,
      fullList: false,
      filters: {
        rows: 50,
        page: "",
        save: false,
        name: "",
        ip: "",
        secret: "",
        username: "",
        password: "",
        api_port: "",
        community: "",
        legacy: "",
        online: "",
        api_connected: "",
        search_query: null,
      },
      checkedBox: true,
      allSelected: false,
      showColumnsSelect: false,
      showAddNas: false,
      columns: {
        name: { name: this.$t("nases.name"), enabled: true },
        ip: { name: this.$t("nases.ip"), enabled: true },
        secret: { name: this.$t("nases.secret"), enabled: false },
        username: { name: this.$t("nases.username"), enabled: false },
        password: { name: this.$t("nases.password"), enabled: false },
        api_port: { name: this.$t("nases.api_port"), enabled: false },
        community: { name: this.$t("nases.community"), enabled: false },
        legacy: { name: this.$t("nases.version"), enabled: false },
        allowed_admins: {
          name: this.$t("nases.allowed_admins"),
          enabled: true,
        },
        allowed_profiles: {
          name: this.$t("nases.allowed_profiles"),
          enabled: false,
        },
        online_sessions: {
          name: this.$t("nases.online_sessions"),
          enabled: true,
        },
        online: { name: this.$t("nases.status"), enabled: true },
        api_connected: { name: this.$t("nases.api"), enabled: true },
        wa_status: { name: this.$t("nases.whatsapp_status"), enabled: false },
        wa_name: {
          name: this.$t("nases.whatsapp_network_name"),
          enabled: false,
        },
        settings: { name: this.$t("nases.settings"), enabled: true },
      },
      autoUpdate: false,
      selection_array: [],
      debounce: null,
      loading_overlay: false,
    };
  },
  async created() {
    this.prepareFilters();
    this.applyFilters();
    this.prepareColumns();
    if (this.$route.query.nas_id) {
      this.openAddNasModal({ id: this.$route.query.nas_id });
    }
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async fetchData() {
      if (this.filters.rows > 0 || this.filters.page > 0) {
        this.fetchDataPortion(this.filters.rows, this.filters.page);
        this.selection_array = [];
        return;
      }
      this.applyFilters();
    },
    async openAddNasModal(nas = null) {
      this.showAddNas = true;
      if (nas) {
        this.$router.push({
          query: { nas_id: nas.id },
        });
      }
      await this.$nextTick();
      var modalElement = document.getElementById("add-device");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showAddNas = false;
      });
      modalInstance.show();
    },
    prepareFilters() {
      var filters = localStorage.getItem("nases_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
      }
    },
    prepareColumns() {
      var cols = localStorage.getItem("nases_columns");
      if (cols != null) {
        cols = JSON.parse(cols);
        this.columns = {
          name: { name: this.$t("nases.name"), enabled: cols[0].enabled },
          ip: { name: this.$t("nases.ip"), enabled: cols[1].enabled },
          secret: { name: this.$t("nases.secret"), enabled: cols[2].enabled },
          username: {
            name: this.$t("nases.username"),
            enabled: cols[3].enabled,
          },
          password: {
            name: this.$t("nases.password"),
            enabled: cols[4].enabled,
          },
          api_port: {
            name: this.$t("nases.api_port"),
            enabled: cols[5].enabled,
          },
          community: {
            name: this.$t("nases.community"),
            enabled: cols[6].enabled,
          },
          legacy: { name: this.$t("nases.version"), enabled: cols[7].enabled },
          allowed_admins: {
            name: this.$t("nases.allowed_admins"),
            enabled: cols[8].enabled,
          },
          allowed_profiles: {
            name: this.$t("nases.allowed_profiles"),
            enabled: cols[9].enabled,
          },
          online_sessions: {
            name: this.$t("nases.online_sessions"),
            enabled: cols[10] != null ? cols[10].enabled : true,
          },
          online: { name: this.$t("nases.status"), enabled: cols[11].enabled },
          api_connected: {
            name: this.$t("nases.api"),
            enabled: cols[12] != null ? cols[12].enabled : true,
          },
          wa_status: {
            name: this.$t("nases.whatsapp_status"),
            enabled: cols[13] != null ? cols[13].enabled : false,
          },
          wa_name: {
            name: this.$t("nases.whatsapp_network_name"),
            enabled: cols[14] != null ? cols[14].enabled : false,
          },
          settings: {
            name: this.$t("nases.settings"),
            enabled: cols[15] != null ? cols[15].enabled : true,
          },
        };
      }
    },
    async applyFilters() {
      this.loading = true;
      var requestString = `nases?filters=1`;
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.name != "")
        requestString += `&name=${this.filters.name}`;
      if (this.filters.ip != "") requestString += `&ip=${this.filters.ip}`;
      if (this.filters.secret != "")
        requestString += `&secret=${this.filters.secret}`;
      if (this.filters.username != "")
        requestString += `&username=${this.filters.username}`;
      if (this.filters.password != "")
        requestString += `&password=${this.filters.password}`;
      if (this.filters.api_port != "")
        requestString += `&api_port=${this.filters.api_port}`;
      if (this.filters.community != "")
        requestString += `&community=${this.filters.community}`;
      if (this.filters.legacy != "")
        requestString += `&legacy=${this.filters.legacy}`;
      if (this.filters.online != "")
        requestString += `&online=${this.filters.online}`;
      if (this.filters.search_query != null)
        requestString += `&search_query=${this.filters.search_query}`;
      if (this.filters.api_connected != "")
        requestString += `&api_connected=${this.filters.api_connected}`;
      const response = await axios.get(requestString);
      this.dataList = response.data.data;
      if (this.filters.save)
        localStorage.setItem("nases_filters", JSON.stringify(this.filters));
      if (this.dataList.length < 1 && this.filters.page != 1) {
        this.filters.page = 1;
        this.applyFilters();
      }
      this.meta = response.data.meta;
      this.loading = false;
      this.dataList.forEach(async (nas) => {
        await this.pingHost(nas);
        // await this.apiHost(nas);
      });
      // clearTimeout(this.debounce);
      // this.debounce = setTimeout(async () => {
      //   const response = await axios.get(requestString);
      //   this.dataList = response.data.data;
      //   if (this.filters.save)
      //     localStorage.setItem("nases_filters", JSON.stringify(this.filters));
      //   if (this.dataList.length < 1 && this.filters.page != 1) {
      //     this.filters.page = 1;
      //     this.applyFilters();
      //   }
      //   this.meta = response.data.meta;
      //   this.loading = false;
      //   this.dataList.forEach(async (nas) => {
      //     await this.pingHost(nas);
      //     // await this.apiHost(nas);
      //   });
      // }, 1000);

      // if (this.sort_col) {
      //   if (this.sort_dir == "ASC") {
      //     this.dataList.sort((a, b) =>
      //       a[this.sort_col] > b[this.sort_col]
      //         ? 1
      //         : b[this.sort_col] > a[this.sort_col]
      //         ? -1
      //         : 0
      //     );
      //   } else {
      //     this.dataList.sort((a, b) =>
      //       a[this.sort_col] < b[this.sort_col]
      //         ? 1
      //         : b[this.sort_col] < a[this.sort_col]
      //         ? -1
      //         : 0
      //     );
      //   }
      // }
    },
    async fetchDataPortion(rows, currentPage) {
      this.filters.rows = rows;
      this.filters.page = currentPage;
      this.loading = true;
      var requestString = `nases?rows=${rows}&page=${currentPage}`;
      const response = await axios.get(requestString);
      this.dataList = response.data.data;
      this.meta = response.data.meta;
      this.loading = false;
    },
    editData(selectedData) {
      this.$router.push(`/nases/${selectedData.id}/edit`);
    },
    async exportSQL(id) {
      this.$swal.fire({
        title: this.$t("control.loading"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      try {
        // Make the Axios request
        const response = await axios.get(`nases/${id}/export`, {
          responseType: "blob", // Important for handling binary data
        });

        // Create a Blob from the response data
        const blob = new Blob([response.data]);

        // Create a temporary URL for the Blob
        const url = window.URL.createObjectURL(blob);

        // Create a temporary anchor element to trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.download = `nas_${id}.sql` || "downloaded-file"; // Set the default file name
        document.body.appendChild(link);
        link.click();

        // Clean up: remove the link and revoke the URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.$swal({
          title: this.$t("control.success"),
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
          backdrop: true,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          title: this.$t("control.error"),
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          icon: "error",
          confirmButtonText: this.$t("control.ok"),
          backdrop: true,
        });
      }
    },
    async deleteData(network) {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("nases.this_will_delete_network_permanently"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(`nases/${network.id}`);
            if (response.status == 200) {
              this.fetchData();
              this.selection_array = [];
            }
            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t("nases.network_has_been_deleted_successfully"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async groupDelete() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "nases.this_will_delete_all_selected_networks_permanently"
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`nases/group`, {
              nases: this.selection_array,
            });
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t(
                "nases.selected_accounts_have_been_deleted_successfull"
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async openQrCodeModal(nas) {
      this.selectedNas = nas;
      this.showQrCode = true;
      await this.$nextTick();
      var modalElement = document.getElementById("qr-code-device");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showQrCode = false;
      });
      modalInstance.show();
    },
    formatDate(date) {
      return moment(date).format("MMMM Do YYYY");
    },
    openContextMenu(e, data) {
      this.selectedData = data;
      this.$refs.menu.open(e);
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    updateColumns() {
      localStorage.setItem(
        "nases_columns",
        JSON.stringify(Object.values(this.columns))
      );
    },
    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    async pingHost(nas) {
      try {
        const response = await axios.get(`nases/${nas.id}/ping`);
        if (response.status == 200) {
          nas.online = response.data.status_ping;
          nas.api_connected = response.data.status_api;
          nas.wa_status = response.data.status_wa;
          return response.data.status == "up";
        }
      } catch (error) {
        return false;
      }
    },
    async apiHost(nas) {
      try {
        const response = await axios.get(`nases/${nas.id}/api`);
        if (response.status == 200) {
          nas.api_connected = response.data.status;
          return response.data.status == "up";
        }
      } catch (error) {
        return false;
      }
    },
    async commitSettings(nas) {
      this.loading = true;
      try {
        const response = await axios.post(`nases/${nas.id}/commit`);
        if (response.status == 200) {
          nas.commited = true;
          this.$router.push({ query: { success: "success" } });
        }
      } catch (error) {}
      this.loading = false;
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem("nases_filters", JSON.stringify(this.filters));
    },
  },
};
</script>
